import { render, staticRenderFns } from "./ckeditor.vue?vue&type=template&id=32af2cde&"
import script from "./ckeditor.vue?vue&type=script&lang=ts&"
export * from "./ckeditor.vue?vue&type=script&lang=ts&"
import style0 from "./ckeditor.vue?vue&type=style&index=0&id=32af2cde&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports